module.exports = __webpack_public_path__ + "static/media/PencilsBackground1280x1920.23695c27.jpg";